import { Component, OnInit, Input } from '@angular/core';
import { GEODeliveryAreaMethod } from '@pages/checkout-app/types';
@Component({
  selector: 'display-geo-settings',
  styles: ['.font12 { font-size: 12px; padding: 0 2px;}'],
  template: `
    <pdq-button [plain]="true" (onClick)="showGeoSettings = !showGeoSettings">{{
      showGeoSettings ? 'Hide location settings' : 'Show location settings'
    }}</pdq-button>
    @if (showGeoSettings) {
      <div class="col gap font12">
        <div>Shipped from: {{ formattedAddress }}</div>
        @if (isInternationalMethod) {
          <div>
            @if (internationalDestinationCountryCodes) {
              <div>Destination country codes: {{ internationalDestinationCountryCodes }}</div>
            }
          </div>
        } @else {
          @if (geoDeliveryArea) {
            <div>{{ geoDeliveryArea }}</div>
          }
          @if (geoDeliveryMethod) {
            <div>{{ geoDeliveryMethod }}</div>
          }
          @if (listedStates) {
            <div>Listed states: {{ listedStates }}</div>
          }
          @if (listedCities) {
            <div>Listed cities: {{ listedCities }}</div>
          }
          @if (excludeStates) {
            <div>Excluded states: {{ excludeStates }}</div>
          }
          @if (excludedCities) {
            <div>Excluded cities: {{ excludedCities }}</div>
          }
        }
      </div>
    }
  `,
  standalone: false,
})
export class DisplayGeoSettingsComponent implements OnInit {
  @Input() shipping;
  showGeoSettings = false;
  formattedAddress = '';
  geoDeliveryArea: string = null;
  geoDeliveryMethod: string = null;
  listedStates: string = null;
  listedCities: string = null;
  excludeStates: string = null;
  excludedCities: string = null;
  isInternationalMethod = false;
  internationalDestinationCountryCodes = null;

  DeliveryMethodMap = {
    [GEODeliveryAreaMethod.LISTED_STATES]: 'listed states',
    [GEODeliveryAreaMethod.LISTED_CITIES]: 'listed cities',
    [GEODeliveryAreaMethod.STATES_PEN_TOOL]: 'pen tool',
    [GEODeliveryAreaMethod.STATES_FROM_ADDRESS_RADIUS]: 'radius',
    [GEODeliveryAreaMethod.STATES_FROM_LIST]: 'list',

    [GEODeliveryAreaMethod.PEN_TOOL]: 'pen tool',
    [GEODeliveryAreaMethod.CITIES_FROM_LIST]: 'list',
    [GEODeliveryAreaMethod.CITIES_FROM_ADDRESS_RADIUS]: 'radius',

    [GEODeliveryAreaMethod.STREETS_FROM_ADDRESS_RADIUS]: 'radius',
    [GEODeliveryAreaMethod.STREETS_FROM_LIST]: 'list',

    [GEODeliveryAreaMethod.CUSTOM_PEN_TOOL]: 'pen tool',
    [GEODeliveryAreaMethod.CUSTOM_FROM_ADDRESS_RADIUS]: 'radius',
  };
  constructor() {}

  ngOnInit() {
    const {
      deliveryAreaSelectMethod,
      shippedFromLocationAddress,
      shippingMethod,
      polygonInputValues,
      internationalSettings,
    } = this.shipping;
    const { category } = shippingMethod;
    this.isInternationalMethod = category?.includes('international');
    this.formattedAddress = `${shippedFromLocationAddress?.country},  ${shippedFromLocationAddress.storeName}`;

    if (
      this.isInternationalMethod &&
      internationalSettings?.countriesAndRegions &&
      Object.keys(internationalSettings.countriesAndRegions).length
    ) {
      this.internationalDestinationCountryCodes = Object.keys(internationalSettings.countriesAndRegions).join(', ');
      return;
    }

    const polygonValues = polygonInputValues[0];
    if (polygonValues?.excludedStates?.length) {
      this.excludeStates = polygonValues.excludedStates.join(', ');
    }
    if (polygonValues?.excludedCities?.length) {
      this.excludedCities = polygonValues.excludedCities.join(', ');
    }
    if (polygonValues?.listedStates?.length) {
      this.listedStates = polygonValues.listedStates.join(', ');
    }
    if (polygonValues?.listedCities?.length) {
      this.listedCities = polygonValues.listedCities.join(', ');
    }
    if (deliveryAreaSelectMethod === GEODeliveryAreaMethod.ALL_CITIES) {
      this.geoDeliveryArea = `Geo area everywhere in ${shippedFromLocationAddress?.country}`;
      this.geoDeliveryMethod = null;
    } else if (deliveryAreaSelectMethod?.includes('states')) {
      this.geoDeliveryArea = `Geo area by states`;
      this.geoDeliveryMethod = `Geo method by ${this.DeliveryMethodMap[deliveryAreaSelectMethod]}`;
    } else if (
      deliveryAreaSelectMethod?.includes('cities') ||
      (deliveryAreaSelectMethod === GEODeliveryAreaMethod.PEN_TOOL && category != 'local')
    ) {
      this.geoDeliveryArea = `Geo area by cities`;
      this.geoDeliveryMethod = `Geo method by ${this.DeliveryMethodMap[deliveryAreaSelectMethod]}`;
    } else if (
      deliveryAreaSelectMethod?.includes('streets') ||
      (deliveryAreaSelectMethod === GEODeliveryAreaMethod.PEN_TOOL && category == 'local')
    ) {
      this.geoDeliveryArea = `Geo area by streets`;
      this.geoDeliveryMethod = `Geo method by ${this.DeliveryMethodMap[deliveryAreaSelectMethod]}`;
    } else if (deliveryAreaSelectMethod?.includes('custom')) {
      this.geoDeliveryArea = `Geo area by custom`;
      this.geoDeliveryMethod = `Geo method by custom ${this.DeliveryMethodMap[deliveryAreaSelectMethod]}`;
    } else if (deliveryAreaSelectMethod === GEODeliveryAreaMethod.ZONES) {
      this.geoDeliveryArea = `Geo area by zones`;
      this.geoDeliveryMethod = null;
    } else if (deliveryAreaSelectMethod === GEODeliveryAreaMethod.ZIP_CODES) {
      this.geoDeliveryArea = `Geo area by zip codes`;
      this.geoDeliveryMethod = null;
    } else if (deliveryAreaSelectMethod === GEODeliveryAreaMethod.COUNTY) {
      this.geoDeliveryArea = `Geo area by county`;
      this.geoDeliveryMethod = null;
    }
  }
}
